import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ApiEndpoints} from '../../_constants/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class ActuatorService {
  private http = inject(HttpClient);
  private apiEndpoints = inject(ApiEndpoints);


  private mapActuatorError() {
    return catchError(err => of({build: {version: `ERROR (${err.status})`}}));
  }

  public servicesInfo(): Observable<any> {
    return this.http.get<any>(this.apiEndpoints.servicesActuatorInfo).pipe(this.mapActuatorError());
  }

  public reportsInfo(): Observable<any> {
    return this.http.get<any>(this.apiEndpoints.reportsActuatorInfo).pipe(this.mapActuatorError());
  }
}
